import { AutoComplete, Col, Form, Input, Row, Select } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../store';
import {
  citySelect,
  cnpjAutoCompSelect,
  cnpjSelect,
  loadRequestCid,
  loadRequestEst,
  nameParcSelect,
  nameSelect,
  stateSelect,
} from '../../store/ducks/estadoCidade/actions';
import {
  clearSelectTransp,
  verificarTranspRequest,
} from '../../store/ducks/transportadoras/actions';
import mask, { unmask } from '../../utils/mask';

import { ModalTransp, SelectControl } from './styles';
import { TextLabel } from 'components/TextLabel';

const { Option } = Select;

const TabsSelectRegister: React.FC = ({ children }) => {
  const estados: any = useSelector((state: ApplicationState) => state.EstadoCidade.estado);
  estados.sort((a: { descricao: string }, b: { descricao: string }) => {
    return a.descricao.toUpperCase() > b.descricao.toUpperCase()
      ? 1
      : a.descricao.toUpperCase() < b.descricao.toUpperCase()
      ? -1
      : 0;
  });

  const loadEstados = useSelector((state: ApplicationState) => state.EstadoCidade.loading);
  const cidades = useSelector((state: ApplicationState) => state.EstadoCidade.data);
  const verificarTransp = useSelector(
    (state: ApplicationState) => state.Transportadoras.verificarTransportadora
  );
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd);

  const [nome, setNome] = useState<any>('');
  const [cnpj, setCnpj] = useState<any>('');
  const [estado, setEstado] = useState<any>(undefined);
  const [cidade, setCidade] = useState<any>(undefined);
  const [selectCnpj, setSelectCnpj] = useState<any>();
  const [selectNomeParceiro, setSelectNomeParceiro] = useState<any>();
  const opTransp = verificarTransp?.map((transDados) => transDados);
  const OptionComplete = AutoComplete.Option;
  const nameTitle: any = children;
  const dispatch = useDispatch<Dispatch<Action>>();

  useEffect(() => {
    // stateInitial();
    dispatch(verificarTranspRequest());
    dispatch(loadRequestEst());
    // eslint-disable-next-line
  }, [dispatch, cddAtivo]);

  useEffect(() => {
    setSelectNomeParceiro(
      opTransp?.find(({ nomeParceiro, cnpj }) => (selectCnpj === cnpj ? nomeParceiro : undefined))
    );
    dispatch(nameParcSelect(selectNomeParceiro));
  }, [dispatch, opTransp, selectNomeParceiro, selectCnpj]);

  // const stateInitial = () => {
  //   setCnpj(undefined);
  //   setSelectCnpj(undefined);
  //   setCidade(undefined);
  //   setEstado(undefined);
  //   setNome(undefined);
  //   setSelectNomeParceiro(undefined);
  //   dispatch(cnpjSelect(undefined));
  //   dispatch(cnpjAutoCompSelect(undefined));
  //   dispatch(citySelect(undefined));
  //   dispatch(clearSelectTransp());
  //   dispatch(verificarTranspRequest());
  // };

  const handleSelectDataChange = (value: any) => {
    setEstado(value);
    dispatch(stateSelect(value));
    dispatch(loadRequestCid(value));
  };

  const handleSelectDataChangeCidade = (value: any) => {
    setCidade(value);
    dispatch(citySelect(value));
  };

  // const onChangeCnpj = (e: any) => {
  //   setCnpj(mask('cpfCnpj', e));

  //   dispatch(cnpjSelect(unmask(e)));
  // };

  const onChangeCnpj = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '');
    const maskedValue = mask('cpfCnpj', value);
    setCnpj(maskedValue);
    dispatch(cnpjSelect(unmask(value)));
  };

  const onChangeName = (e: any) => {
    setNome(e.target.value);
    dispatch(nameSelect(e.target.value));
  };

  // const onSelect = (value: string) => {
  //   setSelectCnpj(value);
  //   dispatch(cnpjAutoCompSelect(value));
  //   setSelectNomeParceiro(
  //     opTransp?.find(({ nomeParceiro, cnpj }) => (selectCnpj === cnpj ? nomeParceiro : undefined))
  //   );
  //   dispatch(nameParcSelect(selectNomeParceiro));
  // };

  return (
    <Form layout="vertical">
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item label={<TextLabel>CNPJ ou CPF</TextLabel>} name="cnpjCpff">
            {/* <AutoComplete
              placeholder="CNPJ/CPF"
              onClear={stateInitial}
              allowClear={true}
              autoClearSearchValue={false}
              onDeselect={stateInitial}
              value={cnpj}
              onChange={onChangeCnpj}
              onSelect={onSelect}
              filterOption={(inpValue, org) =>
                org?.props?.children
                  ?.toString()
                  .replace(/[^\d]/g, '')
                  .toLowerCase()
                  .includes(inpValue?.toLowerCase())
              }
            >
              {
                //verificar isso aqui. aparentemente não está sendo usado
                [cnpj]?.map((em: string) => (
                  <OptionComplete key={em} value={em}>
                    {mask('cpfCnpj', em)}
                  </OptionComplete>
                ))
              }
            </AutoComplete> */}
            <Input
              placeholder="CNPJ/CPF"
              type="text"
              value={cnpj}
              name="cnpjCPF"
              onChange={onChangeCnpj}
            />
          </Form.Item>
        </Col>

        <Col md={12} sm={24} xs={24}>
          {!selectCnpj ? (
            <Form.Item label={<TextLabel>Nome</TextLabel>} name="name">
              <Input
                placeholder={nameTitle}
                type="text"
                value={nome}
                disabled={!cnpj}
                name="nome"
                onChange={onChangeName}
              />
            </Form.Item>
          ) : (
            <Form.Item label={<TextLabel>Nome</TextLabel>} name="name">
              <Input value={selectNomeParceiro?.nomeParceiro} type="text" disabled={!cidade} />
            </Form.Item>
          )}
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          {!selectCnpj ? (
            <Form.Item label={<TextLabel>Estado</TextLabel>} name="estado">
              <SelectControl
                allowClear
                key={estado}
                value={estado}
                loading={loadEstados}
                placeholder={'Estado'}
                disabled={!cnpj}
                onChange={handleSelectDataChange}
              >
                {estados?.map((est: any) => (
                  <Option value={est?.codUf} key={est?.codUf}>
                    {est?.descricao}
                  </Option>
                ))}
              </SelectControl>
            </Form.Item>
          ) : (
            <Form.Item label={<TextLabel>Estado</TextLabel>} name="estado">
              <Input
                value={selectNomeParceiro?.uf}
                type="text"
                placeholder="Estado"
                disabled={!nome}
              />
            </Form.Item>
          )}
        </Col>

        <Col md={12} sm={24} xs={24}>
          {!selectCnpj ? (
            <Form.Item label={<TextLabel>Cidade</TextLabel>} name="cidade">
              <SelectControl
                showSearch
                allowClear
                loading={loadEstados}
                disabled={!cnpj}
                key={cidade}
                placeholder={'Cidade'}
                onChange={handleSelectDataChangeCidade}
                filterOption={(inputVal, elemen) =>
                  elemen?.props.children.toString().toLowerCase().includes(inputVal?.toLowerCase())
                }
                value={cidade}
              >
                {cidades?.map((c: any) => (
                  <Option value={c.codCid} key={c.codCid}>
                    {c.nome}
                  </Option>
                ))}
              </SelectControl>
            </Form.Item>
          ) : (
            <Form.Item label={<TextLabel>Cidade</TextLabel>} name="cidade">
              <Input value={selectNomeParceiro?.cidade} type="text" disabled={!nome} />
            </Form.Item>
          )}
        </Col>
      </Row>
    </Form>
  );
};
export default TabsSelectRegister;
